"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardRepositoryMethods = void 0;
const repository_types_1 = require("./repository.types");
exports.dashboardRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    getDashboardCoreData: {
        callMethod: 'GET',
        endpoint: '/patient/dashboard/core',
    },
    getDashboardOrderCardData: {
        callMethod: 'GET',
        endpoint: '/patient/dashboard/order-card',
    },
    getDashboardActionCardData: {
        callMethod: 'GET',
        endpoint: '/patient/dashboard/action-card',
    },
});
//# sourceMappingURL=dashboard.methods.js.map